<template>
    <div>
        <Row :gutter="8">
            <div class="w-full flex justify-end">
                <div class="mr-2">
                    <p>Filtrar por Cliente</p>
                    <i-select filterable v-model="filters.companyId" clearable @on-clear="() => filters.companyId = 0" @on-change="loadChart" class="w-64">
                        <Option v-for="company in companies" :value="company.value" :key="company.value">{{ company.label }}</Option>
                    </i-select>
                </div>
                <div class="mr-2">
                    <p>Filtrar por vendedor</p>
                    <i-select filterable v-model="filters.salerId" clearable @on-clear="() => filters.salerId = 0" @on-change="loadChart" class="w-64" :disabled="filters.companyId !== 0">
                        <Option v-for="saler in salers" :value="saler.value" :key="saler.value">{{ saler.label }}</Option>
                    </i-select>
                </div>
            </div>
        </Row>
        <Spin size="large" fix v-if="chart.metadata.loading"></Spin>
        <echart :options="chart.options" @click="getCustomersByStatus"></echart>
            <div v-show="metadata.showTable">
                <div @scroll="loadMoreCompanies" class="overflow-auto h-auto" style="max-height:32rem;">
                    <i-table ref="table" :columns="table.columns" :data="table.data" :loading="metadata.loading"/>
                </div>
                <br />
                <span class="mt-2"> Exibindo {{metadata.page + 1}}-{{Math.floor(metadata.companiesNumber / config.companiesNumberPerPage) + 1}} de {{metadata.companiesNumber}}</span>
            </div>
    </div>
</template>

<script>
import clienteMixin from './Mixins/ClienteMixin'
export default {
    mixins: [clienteMixin],
    name: 'inadimplentes',
    data () {
        return {
            table: {
                columns: [
                    {
                        title:'#',
                        key:'clienteId',
                        sortable:true,
                        width: 100
                    },
                    {
                        title:'Cliente',
                        key:'nome',
                        sortable:true,
                        minWidth: 250
                    },
                    {
                        title:'Cliente desde',
                        key:'data_hora_cadastro',
                        sortable:true,
                        minWidth: 150,
                        render: (h, params) => {
                            return h('p', this.formatDate(params.row.cliente_desde))
                        }
                    },
                    {
                        title: "Vencimento da Última parcela Paga",
                        key: "data_vencimento_ultima_parcela_paga",
                        sortable: true,
                        minWidth: 150,
                        render: (h, params) => {
                            return h('p', params.row.data_vencimento_ultima_parcela_paga ? this.formatDate(params.row.data_vencimento_ultima_parcela_paga) : 'Nunca pagou')
                        }
                    },
                    {
                        title: 'Data de Vencimento',
                        key: 'data_vencimento',
                        sortable: true,
                        minWidth: 250,
                        render: (h, params) => {
                            return h('p', this.formatDate(params.row.data_vencimento))
                        }
                    },
                    {
                        title: 'Vendedor',
                        key: 'vendedor_nome',
                        sortable: true,
                        minWidth: 200
                    },
                    {
                        title:'Valor',
                        key:'mensalidade_valor',
                        align: "right",
                        sortable:true,
                        minWidth: 150,
                        render:(h, params)=>{
                            return h('p',
                                this.formatMoney(params.row.mensalidade_valor)
                            )
                        }
                    }
                ]
            }
        }
    },

    methods: {
        async loadChart()
        {
            this.clearMetadata();
            let defaultings = await this.getChart("defaultings");
            let newDefaultings = await this.getChart("newDefaultings");

            const newDefaultingsData = this.defaultingChart(newDefaultings);
            const defaultingsData = this.defaultingChart(defaultings);
            this.chart.options.xAxis = [
                {
                    type : 'category',
                    data : this.config.monthRange,
                    axisLine: {onZero: true},
                    splitLine: {show: false},
                    splitArea: {show: false},
                }
            ]
            this.chart.options.legend = {
                data: [{name: 'Inadimplentes', alias: 'defaultings'}, {name: 'Novos Inadimplentes', alias: 'newDefaultings'}, {name: 'Total', alias: 'total'}]
            }
            this.chart.options.series = [
                {
                    name: 'Inadimplentes',
                    type: 'bar',
                    color:'#F59E00',
                    stack:'clientes',
                    data:defaultingsData,
                    label:{
                        normal:{
                            position:'inside',
                            show:true,
                            color:'#ffffff'
                        }
                    }
                },
                {
                    name:'Novos Inadimplentes',
                    type:'bar',
                    color:'#FECF00',
                    stack:'clientes',
                    data:newDefaultingsData,
                    label:{
                        normal:{
                            position:'inside',
                            show:true,
                        }
                    }
                },
                {
                    name:'Total',
                    type:'line',
                    color: '#EEEE00',
                    label:{
                        normal:{
                            position:'top',
                            show:true
                        }
                    },
                    stack:'clientes',
                    data:this.chartTotalizer(newDefaultingsData, defaultingsData)
            }
            ]
            this.chart.metadata.loading = false;
        }
    }
}
</script>

<style scoped>

</style>